<template>
  <div class="bookMeetings">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('查询日程')" />
    <div class="selectionBar">
      <van-search
        v-model="searchValue"
        :placeholder="$t('搜索')"
        @search="onSearch"
        class="search-box"
      />
      <div class="calendar" @click="dateShow = true">
        <img src="@/assets/images/calendar.png" alt="" />
      </div>
    </div>
    <div class="content" v-if="meetingList && meetingList.length">
      <div class="line"></div>
      <div
        v-for="(item, index) in meetingList"
        :key="item.id"
        :class="index + 1 == meetingList.length ? 'orderListB' : 'orderListD'"
        @click="item.relationType === 'STATION' ? null : gotoMeeting(item)"
      >
        <div class="orderListName">{{ item.calendarTopic }}</div>
        <div class="orderListOther" v-if="item.relationType === 'STATION'">
          <img
            src="@/assets/images/overdueTime.png"
            alt=""
            class="overdueImg"
          />
          <div
            class="orderListOtherName"
            v-if="
              item?.stationConfig &&
              JSON.parse(item.stationConfig).mixMakeDay !== 'DAY'
            "
          >
            （{{ item?.beginTime && getTimeDate(item.beginTime) }}）{{
              item?.stationConfig &&
              item.beginTime &&
              getTime(
                JSON.parse(item.stationConfig).mixMakeDay,
                item.beginTime
              )
            }}-{{
              item?.stationConfig &&
              item.endTime &&
              getTime(JSON.parse(item.stationConfig).mixMakeDay, item.endTime)
            }}
          </div>
          <div v-else class="orderListOtherName">
            {{
              item?.stationConfig &&
              item.beginTime &&
              getTime(
                JSON.parse(item.stationConfig).mixMakeDay,
                item.beginTime
              )
            }}{{ $t('至')
            }}{{
              item?.stationConfig &&
              item.endTime &&
              getTime(JSON.parse(item.stationConfig).mixMakeDay, item.endTime)
            }}
          </div>
        </div>
        <div class="orderListOther" v-if="item.relationType === 'MEETING'">
          <img
            src="@/assets/images/overdueTime.png"
            alt=""
            class="overdueImg"
          />
          <div class="orderListOtherName">
            （{{ getTimeDate(item.calendarStartTime) }}）{{
              getTime(1, item.calendarStartTime)
            }}-{{ getTime(1, item.calendarEndTime) }}
          </div>
        </div>
        <div class="orderListOther">
          <img
            src="@/assets/images/overdueAddress.png"
            alt=""
            class="orderListImg"
          />
          <div class="orderListOtherName">{{ item?.calendarAddress }}</div>
        </div>
        <div
          class="operation"
          v-if="
            item.calendarStaff != user.id &&
            item.relationType != 'VISIT' &&
            item.agree == undefined && // 未处理 agree： true 同意， false 拒绝； undefined： 未处理
            !dayjs().isAfter(dayjs(item.calendarEndTime))
          "
        >
          <div v-if="item.relationType === 'STATION'" class="button_box">
            <div @click.stop="onStartCancel(item)" class="card_button_reserve">
              {{ $t('取消预约') }}
            </div>
            <div
              @click.stop="onOK(item)"
              class="editDestine"
              v-if="
                canYouSignIn(
                  JSON.parse(item.stationConfig).isSign,
                  JSON.parse(item.stationConfig).isH5Sign,
                  getTimeDate(item.beginTime),
                  JSON.parse(item.stationConfig).mixMakeDay,
                  JSON.parse(item.stationConfig).isRelease,
                  JSON.parse(item.stationConfig).releaseTime,
                  isDuringDate(
                    JSON.parse(item.stationConfig).mixMakeDay,
                    item.beginTime,
                    item.endTime,
                    JSON.parse(item.stationConfig).releaseTime,
                    JSON.parse(item.stationConfig).isRelease,
                    item.createdTime
                  )
                )
              "
            >
              {{ $t('签到') }}
            </div>
          </div>
          <div v-else class="button_box">
            <div @click.stop="onRefuse(item, 0)" class="rejectDestine">
              {{ $t('拒绝') }}
            </div>
            <div @click.stop="checkRepeat(item)" class="editDestine">
              {{ $t('同意') }}
            </div>
          </div>
        </div>
        <div
          class="operation"
          v-if="
            item.calendarStaff == user.id &&
            item.relationType == 'MEETING' &&
            !item.actualEndTime &&
            dayjs().isBefore(dayjs(item.endTime))
          "
        >
          <div
            @click.stop="onEarlyEnd(item)"
            class="cancelDestine"
            v-if="item.earlyEnd"
          >
            {{ $t('提前结束') }}
          </div>
          <div
            @click.stop="onCancel(item)"
            class="cancelDestine"
            v-if="!item.earlyEnd"
          >
            {{ $t('取消') }}
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showRefuse"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="ifAgree ? onRefuse(refuseData, 1) : clickeRefuse()"
      class="outsiderStyle"
      :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')"
      :beforeClose="checkRemark"
    >
      <template #title>
        <div class="outsider-title">
          {{ ifAgree ? $t('同意参会') : $t('拒绝参会') }}
        </div>
      </template>
      <!-- <div class="refuse-box">
        <div>{{ifAgree ? '是否确认参加会议？' : '是否拒绝参加会议？'}}</div>
      </div> -->
      <div class="remark-box margin8">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          :placeholder="ifAgree ? $t('请输入留言') : $t('请填写原因说明')"
          :required="!ifAgree"
          :error="!ifAgree && !message"
          size="14px"
        />
      </div>
    </van-dialog>
    <van-dialog
      v-model="showRepeat"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="onRefuse(refuseData, 1)"
      class="outsiderStyle"
      :cancelButtonText="$t('取消')"
      :confirmButtonText="$t('确认')"
    >
      <template #title>
        <div class="repeat-title">{{ $t('同意参会') }}</div>
      </template>
      <div class="repeat-box">
        <div class="repeat-tip">
          {{
            $t(
              '本次会议时间段与您参与的以下会议存在时间重叠，是否确认继续参会？'
            )
          }}
        </div>
        <div
          :style="{
            paddingBottom: repeatList.length == 1 ? '1.07vw' : '2.13vw',
          }"
          class="repeat-info"
        >
          <div
            v-for="item in repeatList"
            :key="item.appointmentId"
            class="repeat-info-box"
          >
            <div>{{ item.appointmentTopic }}</div>
            <div>
              {{ dayjs(item.beginTime).format('HH:mm') }}-{{
                dayjs(item.endTime).format('HH:mm')
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="remark-box margin-repaet">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          :placeholder="$t('请输入留言')"
          size="14px"
        />
      </div>
    </van-dialog>
    <van-dialog
      v-model="showCancel"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="clickeCancel"
      class="outsiderStyle"
      :cancelButtonText="$t('暂不')"
      :confirmButtonText="$t('确定')"
    >
      <template #title>
        <div class="outsider-title">{{ $t('取消预订') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{ dayjs(cancelData.beginTime).format('YYYY/MM/DD') }}
          {{ dayjs(cancelData.beginTime).format('HH:mm') }}-
          {{ dayjs(cancelData.endTime).format('HH:mm') }}
        </div>
        <div>{{ $t('地点：') }}{{ cancelData.address || $t('线上') }}</div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showEarlyEnd"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="clickeEarlyEnd"
      class="outsiderStyle"
      :cancelButtonText="$t('暂不')"
      :confirmButtonText="$t('确定')"
    >
      <template #title>
        <div class="outsider-title">{{ $t('提前结束') }}</div>
      </template>
      <div class="cancel-box">
        <div class="first-cancel">
          {{ $t('时间：')
          }}{{ dayjs(earlyEndData.beginTime).format('YYYY/MM/DD') }}
          {{ dayjs(earlyEndData.beginTime).format('HH:mm') }}-
          {{ dayjs(earlyEndData.endTime).format('HH:mm') }}
        </div>
        <div>{{ $t('地点：') }}{{ earlyEndData.address || $t('线上') }}</div>
      </div>
    </van-dialog>
    <van-popup
      v-model="dateShow"
      position="bottom"
      :style="{ height: '630px' }"
    >
      <div class="dateModalTab">
        <div class="dateModalList">
          <div
            v-for="item in allTime"
            :key="item.key"
            :style="{
              backgroundColor: item.backgroundColor,
              color: item.color,
            }"
            class="dateModalListOne"
            @click="choseTime(item)"
          >
            <div class="dateModalListText">
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
      <van-calendar
        @confirm="onConfirm"
        @select="onSelect"
        :title="$t('日期选择')"
        :min-date="minDate"
        color="#009BFF"
        :formatter="formatter"
        :poppable="false"
        :style="{ height: '500px' }"
      />
    </van-popup>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import {
  queryAllMettingList,
  updateAppointmentStatus,
  deleteAppointment,
  cancelMeeting,
  cancelOnlineMeeting,
  queryCalendar,
  queryCalendarStation,
} from '@/services/api'
import Vue from 'vue'
import dayjs from 'dayjs'
import moment from 'moment'
import {
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  Popup,
  PullRefresh,
  List,
  Loading,
  Field,
} from 'vant'
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Popup)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Field)

export default {
  name: 'BookMeetings',
  components: {
    NavBar,
  },
  data() {
    return {
      searchValue: '',
      dateShow: false,
      selectTime: {},
      endTime: '',
      startTime: '',
      allTime: [
        {
          key: 1,
          value: this.$t('全部时间'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 2,
          value: this.$t('一周内'),
          color: '#ffffff',
          backgroundColor: '#009BFF',
        },
        {
          key: 3,
          value: this.$t('一月内'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
      ],

      sourceIsH5: true,
      minDate: new Date(2022, 0, 1),
      meetingList: [],
      repeatList: [],
      showCancel: false,
      cancelData: {},
      showEarlyEnd: false,
      earlyEndData: {},
      refuseData: {},
      showRepeat: false,
      showRefuse: false,
      ifAgree: false,
      message: '',
    }
  },
  methods: {
    async onOK(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.relationId,
        state: 'YES',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getMettingList({})
        Toast(this.$t('签到成功'))
      } else {
        Toast(this.$t('此时间段不可签到！'))
      }
    },
    async onStartCancel(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.relationId,
        state: 'NO',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getMettingList({})
        Toast(this.$t('取消成功！'))
      } else {
        Toast(this.$t('此时间段不可取消预约！'))
      }
    },
    onSearch(val) {
      let params = {}
      this.searchValue = val
      if (this.startTime) {
        params['beginTime'] = this.startTime
        params['endTime'] = this.endTime
        if (val) {
          params['context'] = this.searchValue
        }
        this.getMettingList(params)
      } else {
        if (val) {
          params['context'] = this.searchValue
          this.getMettingList(params)
        } else {
          this.meetingList = []
        }
      }
    },
    choseTime(data) {
      this.date = ''
      this.originDate = ''
      this.allTime.map((item) => {
        if (item.key == data.key) {
          item.color = '#ffffff'
          item.backgroundColor = '#009BFF'
          this.selectTime = { key: item.key, value: item.value }
        } else {
          item.color = '#666666'
          item.backgroundColor = '#F4F4F4'
        }
      })
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    formatDate(date) {
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')

      return this.$t('{slot1}月{slot2}日 {slot3}', {
        slot1: date.getMonth() + 1,
        slot2: date.getDate(),
        slot3: weekday[date.getDay()],
      })
    },
    async getMettingList(params) {
      let meetingArr = []
      params['developerId'] = this.user.companyId
      params['staffId'] = this.user.id
      params['developerId'] = this.user.companyId
      params['companyId'] = this.user.companyId
      params['pageNum'] = 0
      params['pageSize'] = 10000
      try {
        const newRes = await queryCalendar(params)
        newRes?.results?.map((item) => {
          let startArr = item.calendarStartTime.split(' ')[1].split(':')
          let endArr = item.calendarEndTime.split(' ')[1].split(':')
          let start = startArr[0] + ':' + startArr[1]
          let end = endArr[0] + ':' + endArr[1]
          item.time = start + '-' + end
          item.earlyEnd = item?.actualStartTime
            ? true
            : dayjs().isBefore(dayjs(item.calendarStartTime))
            ? false
            : true
          meetingArr.push(item)
        })

        // 合并工位的数据
        let newResStation = await queryCalendarStation(params)
        newResStation = newResStation.map((item) => ({
          relationType: 'STATION',
          calendarTopic: item?.title,
          calendarAddress: item?.address,
          relationId: item?.visitId,
          ...item,
        }))
        meetingArr = meetingArr.concat(newResStation || [])
        meetingArr = meetingArr.sort(
          (a, b) => dayjs(a.beginTime).valueOf() - dayjs(b.endTime).valueOf()
        )

        this.meetingList = meetingArr.sort(
          (a, b) =>
            new Date(b.calendarStartTime) - new Date(a.calendarStartTime)
        )
        console.log(
          meetingArr.sort(
            (a, b) =>
              new Date(b.calendarStartTime) - new Date(a.calendarStartTime)
          ),
          99
        )
      } catch (error) {
        console.log(error)
      }
    },
    getTimeDate(value) {
      return moment(value).calendar(null, {
        sameDay: this.$t('[今天]'),
        nextDay: this.$t('[明天]'),
        nextWeek: this.$t('[下周]'),
        lastDay: this.$t('[昨天]'),
        lastWeek: this.$t('[上周]'),
        sameElse: this.$t('[一周以后]'),
      })
    },
    isDuringDate(mixMakeDay, start, end, releaseTime, isRelease, creatTime) {
      // if (mixMakeDay === 'DAY') {
      //   const curDate = new Date(
      //     moment(moment('12:00:00', 'HH:mm:ss').subtract(0, 'day')).format(
      //       'YYYY-MM-DD HH:mm:ss'
      //     )
      //   )
      //   const startDate = new Date(start)
      //   const endDate = new Date(end)
      //   if (curDate >= startDate && curDate <= endDate) {
      //     return true
      //   }
      //   return false
      // } else {
      const curDate = new Date()
      const startDate = new Date(start)
      let actuallyStart = dayjs(start).isBefore(dayjs(creatTime))
        ? creatTime
        : start
      if (isRelease) {
        const endDate = this.ExtensionOfTime(actuallyStart, releaseTime)
        if (curDate >= startDate && curDate <= endDate) {
          return true
        }
        return false
      } else {
        const endDate = new Date(end)
        if (curDate >= startDate && curDate <= endDate) {
          return true
        }
        return false
      }
      // }
    },
    canYouSignIn(
      isSign,
      isH5Sign,
      today,
      mixMakeDay,
      isRelease,
      releaseTime,
      isDuringDate
    ) {
      if (isSign && isH5Sign && today === this.$t('今天')) {
        // if (mixMakeDay !== 'DAY') {
        if (isDuringDate) {
          if (isRelease) {
            if (releaseTime) {
              return true
            } else {
              return false
            }
          }
          return true
        }
        return false
        // } else {
        //   if (isDuringDate) {
        //     return true
        //   }
        //   return false
        // }
      }
    },
    getTime(mixMakeDay, value) {
      if (mixMakeDay !== 'DAY') {
        return moment(value).format('HH:mm')
      }
      return moment(value).format('YYYY-MM-DD HH:mm')
    },
    onConfirm(date) {
      this.dateShow = false
      let params = {}
      if (this.selectTime.key) {
        this.date = ''
        this.originDate = ''
        if (this.selectTime.key == 1) {
          let day = new Date()
          this.originDate = day
          this.startTime = ''
          this.endTime = ''
        } else if (this.selectTime.key == 2) {
          let day = new Date()
          this.originDate = day
          this.startTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
          this.endTime = dayjs(day).add(6, 'day').format('YYYY-MM-DD 23:59:59')
        } else {
          let day = new Date()
          this.originDate = date
          this.startTime = dayjs(day).format('YYYY-MM-DD 00:00:00')
          this.endTime = dayjs(day).add(30, 'day').format('YYYY-MM-DD 23:59:59')
        }
      } else {
        this.date = this.formatDate(date)
        this.originDate = date
        this.startTime = dayjs(date).format('YYYY-MM-DD 00:00:00')
        this.endTime = dayjs(date).format('YYYY-MM-DD 23:59:59')
      }
      if (this.startTime) {
        params['beginTime'] = this.startTime
        params['endTime'] = this.endTime
      }
      if (this.searchValue) {
        params['context'] = this.searchValue
      }
      this.getMettingList(params)
    },
    onSelect(date) {
      this.selectTime = { key: '', value: '' }
      this.allTime.map((item) => {
        item.color = '#666666'
        item.backgroundColor = '#F4F4F4'
      })
    },
    gotoMeeting(data) {
      if (data.relationType == 'VISIT') {
        this.$router.push(`/visitorInfo/${data.relationId}`)
      } else if (!data.relationType) {
        // 自定义日程没有type
        this.$router.push(`/scheduleInfo/?id=${data.id}`)
      } else {
        this.$router.push({
          name: 'MettingInforRead',
          query: {
            appointmentId: data.relationId,
          },
        })
      }
    },
    clickeCancel() {
      this.showCancel = false
      this.isCancel = true
      if (!dayjs().isBefore(dayjs(this.cancelData.beginTime))) {
        Toast(this.$t('本会议已开始，不可取消，请刷新获取最新状态！'))
        return
      }
      if (
        this.cancelData?.address &&
        this.cancelData?.address != this.$t('线上会议')
      ) {
        cancelMeeting(this.cancelData.meetingId).then(() => {
          //取消成功
          Toast(this.$t('会议已取消！'))
          this.getMettingList(this.newDay)
        })
      } else {
        cancelOnlineMeeting(this.cancelData.meetingId).then(() => {
          Toast(this.$t('会议已取消！'))
          this.getMettingList(this.newDay)
        })
      }
    },
    onCancel(data) {
      this.cancelData = data
      this.showCancel = true
    },
    clickeEarlyEnd() {
      this.showEarlyEnd = false
      this.isCancel = true
      if (this.earlyEndData) {
        deleteAppointment(this.earlyEndData.meetingId).then(() => {
          //取消成功
          Toast(this.$t('会议已提前结束！'))
          this.getMettingList(this.newDay)
        })
      }
    },
    onEarlyEnd(data) {
      this.earlyEndData = data
      this.showEarlyEnd = true
    },
    async checkRepeat(data) {
      const res = await dateOverlap({
        staffIds: this.user.id,
        beginTime: data.beginTime,
        endTime: data.endTime,
      })
      if (res.length) {
        let arr = res[0]?.dateOverlaps.filter(
          (item) => item.appointmentId != data.meetingId
        )
        if (arr.length) {
          this.repeatList = arr
          this.refuseData = data
          this.showRepeat = true
        } else {
          this.ifAgree = true
          this.refuseData = data
          this.showRefuse = true
        }
      } else {
        this.ifAgree = true
        this.refuseData = data
        this.showRefuse = true
      }
    },
    ExtensionOfTime(value, releaseTime) {
      const event = new Date(value)
      const min = event.getMinutes()
      return event.setMinutes(min + (releaseTime - 0))
    },
    async onRefuse(data, flag) {
      let staffId = this.user.id
      let params = {}
      let value = {
        appointmentRecordId: data.relationId,
        staffId,
        opinion: flag ? true : false,
      }
      if (!flag) {
        this.ifAgree = false
        this.refuseData = data
        this.showRefuse = true
      } else {
        if (this.message) {
          await saveMeetingMessage({
            staffId,
            remark: this.message,
            meetingId: this.refuseData.id,
          })
        }
        refuseMeeting(value).then(async (res) => {
          Toast(this.$t('会议已确认！'))
          if (this.startTime) {
            params['beginTime'] = this.startTime
            params['endTime'] = this.endTime
          }
          if (this.searchValue) {
            params['context'] = this.searchValue
          }
          this.getMettingList(params)
          this.showRepeat = false
          this.message = ''
        })
      }
    },
    async clickeRefuse() {
      let params = {}
      if (!this.message && !this.ifAgree) {
        return
      }
      let staffId = this.user.id
      let value = {
        appointmentRecordId: this.refuseData.meetingId,
        staffId,
        opinion: false,
      }
      await saveMeetingMessage({
        staffId,
        remark: this.message,
        meetingId: this.refuseData.id,
        agree: 0,
      })
      const res = await refuseMeeting(value)
      Toast(this.$t('会议已拒绝！'))
      if (this.startTime) {
        params['beginTime'] = this.startTime
        params['endTime'] = this.endTime
      }
      if (this.searchValue) {
        params['context'] = this.searchValue
      }
      this.getMettingList(params)
    },
    checkRemark(action, done) {
      if (action === 'confirm') {
        if (!this.message && !this.ifAgree) {
          done(false)
        } else {
          done()
        }
      } else {
        done()
        this.message = ''
      }
    },
  },
  mounted() {
    this.height = document.body.scrollHeight - 135
    this.selectTime = { key: '2', value: this.$t('一周内') }
    this.originDate = new Date()
    this.user = JSON.parse(localStorage.getItem('user'))
    this.onConfirm(new Date())
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.van-tab--active {
  color: #009bff !important;
  font-size: 14px;
}
.van-tabs {
  background: #ffffff !important;
  font-size: 14px;
}
.bookMeetings {
  position: relative;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card_button_reserve {
  width: 80px;
  height: 28px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid #009bff;
  font-size: 13px;
  font-weight: 400;
  color: #009bff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}
.selectionBar {
  height: 40px;
  background: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;
  .calendar {
    // width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }
}
/deep/.date-border {
  color: #009bff;
}
.dateModalTab {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 80px;
  padding: 17px 0 13px;
  overflow: hidden;
  .dateModalList {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    padding: 0 5px;
    padding-left: 16px;
    margin-bottom: 13px;

    .dateModalListOne {
      margin-right: 8px;
      border-radius: 4px;
    }
  }
}
.overdueImg {
  width: 12px;
  height: 12px;
  opacity: 0.4;
  margin-right: 6px;
}
.dateModalListText {
  width: 80px;
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}
.button_box {
  display: flex;
  position: relative;
  top: 5px;
}
.van-search {
  width: 320px !important;
  height: 30px !important;
  padding-left: 16px !important;
  padding-right: 0 !important;
  margin-right: 15px !important;
}
.content {
  padding: 10px 6px 0;
  margin-top: 10px;
  .line {
    width: '100%';
    height: 1px;
    background: #eeeeee;
  }
}
.orderListD {
  width: '100%';
  height: 103px;
  border-bottom: 1px solid #eeeeee;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .orderListName {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    font-size: 17px;
    font-weight: 500;
    color: #333333;
  }

  .orderListOther {
    display: flex;
    // justify-content: center;
    align-content: center;
    margin-top: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;

    .orderListImg {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }
}
.orderListB {
  width: '100%';
  height: 103px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .orderListName {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    font-size: 17px;
    font-weight: 500;
    color: #333333;
  }

  .orderListOther {
    display: flex;
    // justify-content: center;
    align-content: center;
    margin-top: 10px;

    .orderListImg {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }
}
// .orderListOtherName {
//   font-size: 13px;
//   font-weight: 400;
//   color: #666666;
// }
.orderListOtherName {
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.operation {
  position: absolute;
  bottom: 19px;
  right: 7px;
  display: flex;
  align-items: center;

  .rejectDestine {
    width: 64px;
    height: 28px;
    background: #ffffff;
    border-radius: 15px;
    border: 1px solid #ffa39e;
    font-size: 13px;
    font-weight: 400;
    color: #ff4d4f;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }

  .editDestine {
    width: 64px;
    height: 28px;
    background: #009bff;
    border-radius: 24px;
    font-size: 13px;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/deep/.van-cell::after {
  border: none;
}
/deep/.outsiderStyle {
  width: 296px;
  .outsider-title {
    font-size: 18px;
    line-height: 24px;
  }
  .van-cell::after {
    border: none;
  }
  .van-dialog__header {
    padding: 32px 0px 13px;
  }
  .cancel-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 0 20px 49px;
    .first-cancel {
      margin-bottom: 7px;
    }
  }
  .refuse-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 10px 0 41px;
    display: flex;
    justify-content: center;
  }
  .overdueOther {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 10px;

    .overdueImg {
      width: 12px;
      height: 12px;
      opacity: 0.4;
    }

    .overdueOtherName {
      font-size: 13px;
      font-weight: 400;
      color: #666666;
      opacity: 0.4;
    }
  }
  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }
  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }
  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }
  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }
  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}
.repeat-title {
  margin-top: -8px;
}
.repeat-box {
  margin-top: -5px;
  .repeat-tip {
    padding: 0 26px;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    margin-bottom: 16px;
  }
}
.repeat-info {
  padding-left: 21px;
  padding-right: 21px;
  font-size: 12px;
  color: #999999;
  line-height: 24px;
  .repeat-info-box {
    display: flex;
    justify-content: space-between;
  }
}
.remark-box {
  width: 224px;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}
.margin8 {
  margin: 0 auto 8px;
}
.margin-repaet {
  margin: 8px auto 16px;
}
.cancelDestine {
  width: 64px;
  height: 28px;
  border-radius: 24px;
  border: 1px solid #009bff;
  color: #009bff;
  font-size: 13px;
  margin-right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
